import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_replenishment_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_algo: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrule: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_stock_replenishment_event_hdr_RowClass
  implements bl_inv_stock_replenishment_event_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  guid_algo: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrule: fromDatatype.VrsnDataFieldInterface;
}

enum VisibilityEnum {
  DEFAULT,
  PRIVATE,
  PUBLIC,
}

enum RecurringUpdateEnum {
  THIS_EVENT,
  THIS_AND_FOLLOWING_EVENTS,
  ALL_EVENTS,
}
